import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { assert } from "@/common/assert";
import PhotoSwipe from "photoswipe";
import "@/pages/vendors/photoSwipe/vendor.photoswipe.photoswipe.scss";
import "@/pages/vendors/photoSwipe/vendor.photoswipe.default-skin.scss";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import { FHTMessageType } from "@/models/MessageTypes";
import { photoSwipeHtml } from "@/pages/modules/imagePhotoswipe/photoswipeHtml";
import "./photoSwipe.scss";
import { formatImageUrl } from "@/common/utils";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum";

var PhotoSlider =
/** @class */
function (_super) {
  __extends(PhotoSlider, _super);

  function PhotoSlider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.pswpRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  PhotoSlider.prototype.componentDidMount = function () {
    var $pswp = $(".pswp");

    if (!$pswp.length) {
      $pswp = $(photoSwipeHtml).appendTo(document.body);
    }

    var pswpElement = $pswp.get(0);
    assert(pswpElement, "pswp falsy");
    var imageMessages = this.props.currentContactMessages.filter(function (m) {
      return m.messageType === FHTMessageType.Image;
    }).map(function (m) {
      return m;
    });
    var items = imageMessages.map(function (m) {
      return {
        src: formatImageUrl(m.imageUrl, ImageSizeTypeEnum.Large),
        msrc: formatImageUrl(m.imageUrl, ImageSizeTypeEnum.Thumbnail200whFill),
        w: m.imageSize.width,
        h: m.imageSize.height
      };
    });
    var index = 0;

    for (var i = 0; i < imageMessages.length; i++) {
      assert(this.props.clickedImageMessage, "click message prop not exist");

      if (imageMessages[i].id === this.props.clickedImageMessage.id) {
        index = i;
        break;
      }
    }

    var options = {
      history: false,
      focus: false,
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
      index: index
    };
    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
    gallery.listen("close", this.props.onCloseSlider); //gallery is automatically destroyed after close so no need to explicitly destroy it in componentWillUnmount
  };

  PhotoSlider.prototype.render = function () {
    return _jsx("span", {}, void 0);
  };

  return PhotoSlider;
}(React.Component);

export default PhotoSlider;